/**
 * Profile service — student, tutor, organization profile CRUD.
 */
import apiClient from './apiClient';

// ==================== Student ====================

export const createStudentProfile = async (profileData) => {
    return apiClient.post('/profiles/student', profileData);
};

export const getMyStudentProfile = async () => {
    return apiClient.get('/profiles/student/me');
};

export const updateStudentProfile = async (profileData) => {
    return apiClient.put('/profiles/student/me', profileData);
};

// ==================== Tutor ====================

export const createTutorProfile = async (profileData) => {
    return apiClient.post('/profiles/tutor', profileData);
};

export const getMyTutorProfile = async () => {
    return apiClient.get('/profiles/tutor/me');
};

export const updateTutorProfile = async (profileData) => {
    return apiClient.put('/profiles/tutor/me', profileData);
};

// ==================== Organization ====================

export const createOrganizationProfile = async (profileData) => {
    return apiClient.post('/profiles/organization', profileData);
};

export const getMyOrganizationProfile = async () => {
    return apiClient.get('/profiles/organization/me');
};

export const updateOrganizationProfile = async (profileData) => {
    return apiClient.put('/profiles/organization/me', profileData);
};

// ==================== Photo upload ====================

export const uploadPhoto = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post('/upload/photo', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};
